import React, {
  createContext,
  useState,
  useContext,
  useCallback,
} from "react";
import { Snackbar, Stack, Typography, Box } from "@mui/material";
import LucideIcon from "../LucideIcon";

const SnackbarContext = createContext(null);

const ICONS = {
  success: { name: "CircleCheck", color: "#2e7d32" },
  error: { name: "CircleX", color: "#d32f2f" },
  warning: { name: "AlertTriangle", color: "#ed6c02" },
  info: { name: "Info", color: "#0288d1" },
};

export const SnackbarProviderV2 = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    variant: "success",
  });

  const showSnackbar = useCallback((message, variant = "success") => {
    setSnackbar({ open: true, message, variant });
  }, []);

  const closeSnackbar = useCallback(() => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  const icon = ICONS[snackbar.variant];

  return (
    <SnackbarContext.Provider value={showSnackbar}>
      {children}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{
            maxWidth: 420,
            minWidth: {xs: '95vw', sm:420},
            px: 2,
            py: 1.5,
            borderRadius: "12px",
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: `gainsboro`,
            boxShadow: "0px 8px 30px rgba(0,0,0,0.12)",
          }}
        >
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "8px",
              // bgcolor: `${snackbar.variant}.light`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LucideIcon
              name={icon.name}
              size={18}
              color={icon.color}
            />
          </Box>

          <Typography
            fontSize={13}
            fontWeight={550}
            color="text.primary"
            noWrap
          >
            {snackbar.message}
          </Typography>
        </Stack>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

export const useSnackbarV2 = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error("useSnackbar must be used within SnackbarProvider");
  }
  return context;
};
